export const dateInZone = (instant, timezone) => {
  const parts = new Intl.DateTimeFormat('en-CA', {timeZone: timezone, year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date(instant));
  return ['year','month','day'].map(type => parts.find(p => p.type === type).value).join('-');
};
export function availabilityDates(date, gymZone, browserZone) {
  if (gymZone === browserZone) return [date];
  // Cover the largest IANA offset difference (26 hours), including DST.
  const noon = new Date(`${date}T12:00:00Z`).getTime();
  return [...new Set([-2,-1,0,1,2].map(offset => dateInZone(noon + offset * 86400000, gymZone)))];
}
export function slotsForBrowserDate(groups, date, timezone) {
  const unique = new Map();
  for (const slot of groups.flat()) {
    if (dateInZone(slot.start, timezone) !== date) continue;
    unique.set(JSON.stringify([slot.start,slot.duration,slot.coachId,slot.roomId,slot.classKey]), slot);
  }
  return [...unique.values()].sort((a,b)=>new Date(a.start)-new Date(b.start));
}
